import React, { useEffect, useState } from "react";
import { Button, Heading, Modal } from "../../components/Common";
import { Search } from "../../components/Common/Table";
import { VscFilter } from "react-icons/vsc";
import { useNavigate, useLocation } from "react-router-dom";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import {
  copyForm,
  exportForm,
  extendForm,
  formAssign,
  formDelete,
  formStatusChange,
  previewForm,
  surveyFormList,
} from "../../Service/form.service";
import { GroupDropdown } from "../../Service/group.service";
import { saveAs } from "file-saver";

import {
  IconButton,
  Paper,
  Stack,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Chip,
  Typography,
} from "@mui/material";
import { BiSolidEdit } from "react-icons/bi";
import { GoClock } from "react-icons/go";
import * as DropdownMenu from "@radix-ui/react-dropdown-menu";
import { HiOutlineDuplicate, HiOutlineTrash } from "react-icons/hi";
import FilterForm from "./FilterForm";
import { MdOutlineAssignment } from "react-icons/md";
import moment from "moment";
import Pagination from "../../components/Common/Table/Pagination";
import { notificationSuccess } from "../../state/Action/NotificationAction";
import { useDispatch } from "react-redux";
import {
  formFilterInitialValues,
  assignFormInitialValues,
  extendFormInitialValues,
} from "../../helper/initialValues";
import { useFormik } from "formik";
import {
  extendFormValidationSchema,
  formAssignValidationSchema,
} from "../../helper/validation";
import TableRowsLoader from "../../components/Common/Loader/Skeleton";
import CryptoJS from "crypto-js";
import { TiExportOutline } from "react-icons/ti";
import { IsDelete, IsWrite } from "../../helper/handlePermission";
import ExportModal from "../../components/Common/modals/ExportModal";

const FormManagement = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const secretKey = "your-secret-key"; // Use a secure key

  const locationAuditorId = location.state?.auditorId || new URLSearchParams(location.search).get("auditorId");
  const locationAuditorName = location.state?.auditorName || "";

  const [filterAuditor, setFilterAuditor] = useState(() => {
    if (locationAuditorId) {
      return {
        id: locationAuditorId,
        name: locationAuditorName,
      };
    }
    return null;
  });

  useEffect(() => {
    if (locationAuditorId) {
      setFilterAuditor({
        id: locationAuditorId,
        name: locationAuditorName,
      });
      setPage(0);
    }
  }, [locationAuditorId, locationAuditorName]);

  const editPermissions = IsWrite("From Management");
  const deletePermissions = IsDelete("From Management");

  const [isModalOpen, setIsModalOpen] = useState({
    open: false,
    currentComponent: "",
    para: "",
    head: "",
  });
  const [exportModal, setExportModal] = useState({
    open: false,
    formId: "",
    formTitle: "",
    submissionCount: 0,
  });
  const [search, setSearch] = useState("");
  const [csvData, setCsvData] = useState([]);
  const [value, setValue] = useState("");
  const [page, setPage] = React.useState(0);
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const [formData, setFormData] = useState([]);
  const [totalData, setTotalData] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [groupData, setGroupData] = useState([]);
  const [sortConfig, setSortConfig] = useState({
    key: "",
    direction: "",
  });

  const encryptUrlParams = (params) => {
    const encrypted = CryptoJS.AES.encrypt(
      JSON.stringify(params),
      secretKey
    ).toString();
    return encrypted;
  };
  const toggleDrawer = () => {
    setOpenDrawer(!openDrawer);
  };

  useEffect(() => {
    getFormData(page, search);
  }, [page, search, sortConfig, filterAuditor]);

  useEffect(() => {
    getGroupDropdown();
  }, []);

  const formik1 = useFormik({
    initialValues: formFilterInitialValues,
    onSubmit: async (values) => {
      setOpenDrawer(false);
      getFormData(page, search);
    },
  });

  const formik = useFormik({
    initialValues:
      isModalOpen.currentComponent === "assignForm"
        ? assignFormInitialValues
        : extendFormInitialValues,
    validationSchema:
      isModalOpen.currentComponent === "assignForm"
        ? formAssignValidationSchema
        : extendFormValidationSchema,
    onSubmit: async (values) => {
      let payload = {};

      switch (isModalOpen.currentComponent) {
        case "assignForm":
          payload = { groups: values.groups };
          break;
        case "extend":
          payload = { expiresDate: values.extendDate };
          break;
        default:
          payload = null;
      }

      let res;

      if (payload) {
        res = await (isModalOpen.currentComponent === "assignForm"
          ? formAssign(isModalOpen.id, payload)
          : extendForm(isModalOpen.id, payload));
      } else {
        res = null;
      }

      if (res?.status) {
        dispatch(
          notificationSuccess({
            show: true,
            type: "success",
            message: res.message || "Success",
          })
        );
        setIsModalOpen({
          open: false,
          currentComponent: "",
          para: "",
          head: "",
          isEdit: false,
          isView: false,
        });

        formik.resetForm();
        getFormData(page, search);
      } else {
        dispatch(
          notificationSuccess({
            show: true,
            type: "error",
            message:
              res.message ?? "Something went wrong. Please try again later.",
          })
        );
      }
    },
  });

  console.log("FormManagement", formik.values);

  const getGroupDropdown = async () => {
    const res = await GroupDropdown();
    if (res.status) {
      setGroupData(res.data);
    } else {
      setGroupData([]);
    }
  };

  const getFormData = async (page, search) => {
    setFormData([]);

    let selectQry = `?page=${
      page + 1
    }&limit=10&search=${search}&fromExpireDate=${
      formik1.values.fromExpireDate
    }&toExpireDate=${formik1.values.toExpireDate}&fromPublishedDate=${
      formik1.values.fromPublishedDate
    }&toPublishedDate=${formik1.values.toPublishedDate}&status=${
      filterAuditor ? 1 : formik1.values.status
    }&auditorId=${
      filterAuditor?.id || ""
    }&sortBy=${sortConfig.key}&sortFlag=${sortConfig.direction}`;
    const res = await surveyFormList(selectQry);
    if (res.status) {
      setFormData(res.data);
      setTotalData(res.total);
    } else {
      setFormData(null);
    }
  };

  const changeStatus = async () => {
    setIsModalOpen((prev) => ({ ...prev, loading: true }));
    try {
      const res =
        isModalOpen.type === "status"
          ? await formStatusChange(isModalOpen.id)
          : isModalOpen.type === "delete"
          ? await formDelete(isModalOpen.id)
          : isModalOpen.type === "copy"
          ? await copyForm(isModalOpen.id)
          : isModalOpen.type === "export"
          ? await exportForm(isModalOpen.id)
          : isModalOpen.type === "preview"
          ? await previewForm(isModalOpen.id)
          : null;

    if (res?.status) {
      dispatch(
        notificationSuccess({
          show: true,
          type: "success",
          message: res.message || "Success",
        })
      );
      // let data
      if (isModalOpen.type === "export") {
        const getQuestionText = (q) => {
          if (q === null || q === undefined) return "";
          let text = "";
          if (typeof q === "object") {
            text = q.question || q.title || q.name || JSON.stringify(q);
          } else {
            text = String(q);
          }
          return text.replace(/\r?\n/g, " ");
        };

        const getAnswerText = (value) => {
          if (value === null || value === undefined || value === "") return "";
          
          if (typeof value === "object") {
            if (Array.isArray(value)) {
              return value.map(val => typeof val === "object" ? getAnswerText(val) : String(val)).join(", ").replace(/\r?\n/g, " ");
            }
            
            if (value.matrixAnswers && Array.isArray(value.matrixAnswers)) {
              const rows = value.matrixAnswers.slice(1).map(row => {
                if (Array.isArray(row)) {
                  return row.map(cell => cell?.value || cell?.answer || "").filter(v => v !== "").join(": ");
                }
                return "";
              }).filter(Boolean);
              return rows.join(", ").replace(/\r?\n/g, " ");
            }
            
            if (value.filesAnswers && Array.isArray(value.filesAnswers)) {
              const paths = value.filesAnswers.map(file => file.serverPath || file.localPath || "").filter(Boolean);
              if (paths.length > 0) {
                const mediaStr = paths.join(", ");
                if (value.answer) {
                  return `${value.answer} (Media: ${mediaStr})`.replace(/\r?\n/g, " ");
                }
                return mediaStr.replace(/\r?\n/g, " ");
              }
            }
            
            let parts = [];
            if (value.answer) {
              parts.push(value.answer);
            }
            if (value.answers) {
              if (Array.isArray(value.answers)) {
                parts.push(value.answers.join(", "));
              } else {
                parts.push(value.answers);
              }
            }
            if (value.audioUrl) {
              parts.push(`(Audio: ${value.audioUrl})`);
            }
            
            if (parts.length > 0) {
              return parts.join(", ").replace(/\r?\n/g, " ");
            }
            
            return JSON.stringify(value).replace(/\r?\n/g, " ");
          }
          
          return String(value).replace(/\r?\n/g, " ");
        };

        const questions = res?.data.questions || [];
        const rawValues = res?.data.values || [];

        const headerRow = questions.map(q => getQuestionText(q));
        const alignedRows = rawValues.map(row => row.map(val => getAnswerText(val)));

        const data = [headerRow, ...alignedRows];

        console.log("data", data);
        const csvContent = data
          .map((row) =>
            row
              .map((value) => `"${value.replace(/"/g, '""')}"`)
              .join(",")
          )
          .join("\n");

        console.log("csvContent", csvContent);

        const blob = new Blob(["\uFEFF" + csvContent], {
          type: "text/csv;charset=utf-8;",
        });

        saveAs(blob, "FormData.csv");
      }
      getFormData(page, search);
      setIsModalOpen({
        open: false,
        currentComponent: "",
        para: "",
        head: "",
        id: "",
        loading: false,
      });
    } else {
      dispatch(
        notificationSuccess({
          show: true,
          type: "error",
          message:
            res?.message || "Something went wrong. Please try again later.",
        })
      );
      setIsModalOpen({
        open: false,
        currentComponent: "",
        para: "",
        head: "",
        id: "",
        loading: false,
      });
    }
  } catch (err) {
    console.error("changeStatus error:", err);
    dispatch(
      notificationSuccess({
        show: true,
        type: "error",
        message:
          err?.response?.data?.message || err?.message || "Something went wrong. Please try again later.",
      })
    );
    setIsModalOpen({
      open: false,
      currentComponent: "",
      para: "",
      head: "",
      id: "",
      loading: false,
    });
  }
};

  const params = {
    page: page + 1,
    search: search,
  };

  console.log("==================", formData)

  return (
    <>
      <Heading head={"Form Management"} />
      <Stack gap={2} mt={1}>
        <Stack
          mb={1}
          flexDirection={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <Search search={search} setSearch={setSearch} setPage={setPage} />
          <Stack flexDirection={"row"} alignItems={"center"} gap={1}>
            {editPermissions && (
              <Button
                buttonName={"Add"}
                size="small"
                onClick={() => {
                  navigate("/formcreation");
                }}
              />
            )}
            <Button
              buttonName={<VscFilter />}
              style={{ padding: "10px 11px" }}
              color="white"
              size="small"
              onClick={toggleDrawer}
              variant="contained"
              sx={{ mt: 2 }}
            />
            <FilterForm
              value={value}
              setValue={setValue}
              openDrawer={openDrawer}
              toggleDrawer={toggleDrawer}
              formik={formik1}
            />
          </Stack>
        </Stack>

        {filterAuditor && (
          <Stack
            flexDirection="row"
            gap={1}
            alignItems="center"
            sx={{
              backgroundColor: "#f8f9fa",
              p: 1.2,
              borderRadius: "8px",
              border: "1px solid #e9ecef",
              mb: 1,
            }}
          >
            <Typography fontSize="13px" fontWeight={600} color="text.secondary">
              Active Filters:
            </Typography>
            <Chip
              size="small"
              color="error"
              variant="outlined"
              label={`📋 Active Surveys for Auditor: ${filterAuditor.name || "Selected Auditor"}`}
              onDelete={() => {
                setFilterAuditor(null);
                setPage(0);
              }}
            />
          </Stack>
        )}

        <TableContainer component={Paper}>
          <Table stickyHeader aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell style={{ cursor: "pointer" }}>
                  <Stack
                    flexDirection={"row"}
                    gap={2}
                    alignItems={"center"}
                    justifyContent={"start"}
                  >
                    <div>{"Sr No."}</div>
                  </Stack>
                </TableCell>
                <TableCell style={{ cursor: "pointer" }}>
                  <Stack
                    flexDirection={"row"}
                    gap={2}
                    alignItems={"center"}
                    justifyContent={"start"}
                  >
                    <div>Name</div>
                  </Stack>
                </TableCell>
                <TableCell
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setSortConfig({
                      key: "createdAt",
                      direction:
                        sortConfig &&
                        sortConfig.key === "createdAt" &&
                        sortConfig.direction === "asc"
                          ? "desc"
                          : "asc",
                    })
                  }
                >
                  <Stack
                    flexDirection={"row"}
                    gap={2}
                    alignItems={"center"}
                    justifyContent={"start"}
                  >
                    <div>Created Date</div>
                    {sortConfig &&
                    sortConfig.key === "createdAt" &&
                    sortConfig.direction === "asc" ? (
                      <IoIosArrowUp className="iconstyle" />
                    ) : (
                      <IoIosArrowDown />
                    )}
                  </Stack>
                </TableCell>
                <TableCell
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setSortConfig({
                      key: "publishedDate",
                      direction:
                        sortConfig &&
                        sortConfig.key === "publishedDate" &&
                        sortConfig.direction === "asc"
                          ? "desc"
                          : "asc",
                    })
                  }
                >
                  <Stack
                    flexDirection={"row"}
                    gap={2}
                    alignItems={"center"}
                    justifyContent={"start"}
                  >
                    <div>Published</div>
                    {sortConfig &&
                    sortConfig.key === "publishedDate" &&
                    sortConfig.direction === "asc" ? (
                      <IoIosArrowUp className="iconstyle" />
                    ) : (
                      <IoIosArrowDown />
                    )}
                  </Stack>
                </TableCell>
                <TableCell
                  style={{ cursor: "pointer" }}
                  onClick={() =>
                    setSortConfig({
                      key: "expiresDate",
                      direction:
                        sortConfig &&
                        sortConfig.key === "expiresDate" &&
                        sortConfig.direction === "asc"
                          ? "desc"
                          : "asc",
                    })
                  }
                >
                  <Stack
                    flexDirection={"row"}
                    gap={2}
                    alignItems={"center"}
                    justifyContent={"start"}
                  >
                    <div>Expires</div>
                    {sortConfig &&
                    sortConfig.key === "expiresDate" &&
                    sortConfig.direction === "asc" ? (
                      <IoIosArrowUp className="iconstyle" />
                    ) : (
                      <IoIosArrowDown />
                    )}
                  </Stack>
                </TableCell>
                <TableCell style={{ cursor: "pointer" }}>
                  <Stack
                    flexDirection={"row"}
                    gap={2}
                    alignItems={"center"}
                    justifyContent={"center"}
                  >
                    <div>Options</div>
                  </Stack>
                </TableCell>
                <TableCell style={{ cursor: "pointer" }}>
                  <Stack
                    flexDirection={"row"}
                    gap={2}
                    alignItems={"center"}
                    justifyContent={"start"}
                  >
                    <div>Status</div>
                  </Stack>
                </TableCell>
                <TableCell style={{ cursor: "pointer" }}>
                  <Stack
                    flexDirection={"row"}
                    gap={2}
                    alignItems={"center"}
                    justifyContent={"start"}
                  >
                    <div>Submitted Priview</div>
                  </Stack>
                </TableCell>
                <TableCell style={{ cursor: "pointer" }}>
                  <Stack
                    flexDirection={"row"}
                    gap={2}
                    alignItems={"center"}
                    justifyContent={"start"}
                  >
                    <div>Result</div>
                  </Stack>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {formData &&
                formData?.map((data) => (
                  <TableRow
                    key={data.id}
                    sx={{
                      "&:last-child td, &:last-child th": { border: 0 },
                      cursor: "pointer",
                    }}
                  >
                    <TableCell
                      className="table-hover"
                      style={{ textAlign: "left" }}
                    >
                      {page * 10 + formData.indexOf(data) + 1}
                    </TableCell>

                    <TableCell style={{ textAlign: "left" }}>
                      {data.title}
                    </TableCell>

                    <TableCell style={{ textAlign: "left" }}>
                      {moment(data.createdAt).format("DD-MM-YYYY")}
                    </TableCell>

                    <TableCell style={{ textAlign: "left" }}>
                      {moment(data.publishedDate).format("DD-MM-YYYY")}
                    </TableCell>

                    <TableCell style={{ textAlign: "left" }}>
                      {moment(data.expiresDate).format("DD-MM-YYYY")}
                    </TableCell>

                    <TableCell style={{ textAlign: "center" }}>
                      {editPermissions || deletePermissions ? (
                        <>
                          {editPermissions && (
                            <>
                              <Tooltip title="Assign">
                                <IconButton
                                  onClick={() => {
                                    const assignedGroupIds = (data?.groups || [])
                                      .map((g) => (typeof g === "object" && g ? g._id || g.id : g))
                                      .filter(Boolean);
                                    formik.setFieldValue("groups", assignedGroupIds);
                                    setIsModalOpen({
                                      open: true,
                                      currentComponent: "assignForm",
                                      id: data?._id,
                                      selectedGroup: assignedGroupIds,
                                      formTitle: data?.title,
                                    });
                                  }}
                                >
                                  <MdOutlineAssignment
                                    size={23}
                                    style={{
                                      backgroundColor: "#ff6a00",
                                      padding: "5px",
                                      color: "white",
                                      borderRadius: "50%",
                                    }}
                                  />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Copy Form">
                                <IconButton
                                  onClick={() => {
                                    setIsModalOpen({
                                      open: true,
                                      currentComponent: "delete",
                                      id: data?._id || data?.id,
                                      type: "copy",
                                      head: "Copy Form",
                                      para: `Are you sure you want to copy "${data?.title || "this form"}"?`,
                                    });
                                  }}
                                >
                                  <HiOutlineDuplicate
                                    size={23}
                                    style={{
                                      backgroundColor: "white",
                                      padding: "5px",
                                      color: "black",
                                      borderRadius: "50%",
                                      pointerEvents: "none",
                                    }}
                                  />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Export Data">
                                <IconButton
                                  onClick={() => {
                                    setExportModal({
                                      open: true,
                                      formId: data?._id || data?.id,
                                      formTitle: data?.title,
                                      submissionCount: data?.submissionCount,
                                    });
                                  }}
                                >
                                  <TiExportOutline
                                    size={23}
                                    style={{
                                      backgroundColor: "white",
                                      padding: "5px",
                                      color: "black",
                                      borderRadius: "50%",
                                      pointerEvents: "none",
                                    }}
                                  />
                                </IconButton>
                              </Tooltip>
                              <Tooltip title="Extend Date">
                                <IconButton
                                  onClick={() => {
                                    setIsModalOpen({
                                      open: true,
                                      currentComponent: "extend",
                                      id: data?._id || data?.id,
                                    });

                                    let today = moment().format("YYYY-MM-DD");
                                    if (
                                      moment(data.expiresDate).format(
                                        "YYYY-MM-DD"
                                      ) > today
                                    ) {
                                      formik.setFieldValue(
                                        "extendDate",
                                        moment(data.expiresDate).format(
                                          "YYYY-MM-DD"
                                        )
                                      );
                                    }
                                  }}
                                >
                                  <GoClock
                                    size={23}
                                    style={{
                                      backgroundColor: "green",
                                      padding: "5px",
                                      color: "white",
                                      borderRadius: "50%",
                                      pointerEvents: "none",
                                    }}
                                  />
                                </IconButton>
                              </Tooltip>
                              {/* //copy data  */}
                              <Tooltip title="Edit Form">
                                <IconButton
                                  onClick={() => {
                                    navigate(
                                      `/formcreation?copy=${data?._id || data?.id}`,
                                      {
                                        state: { id: data?._id || data?.id },
                                      }
                                    );
                                  }}
                                >
                                  <BiSolidEdit
                                    size={23}
                                    style={{
                                      backgroundColor: "gray",
                                      padding: "5px",
                                      color: "white",
                                      borderRadius: "50%",
                                      pointerEvents: "none",
                                    }}
                                  />
                                </IconButton>
                              </Tooltip>
                            </>
                          )}
                          {deletePermissions && (
                            <Tooltip title="Delete">
                              <IconButton
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setIsModalOpen({
                                    id: data?._id || data?.id,
                                    type: "delete",
                                    open: true,
                                    currentComponent: "delete",
                                    head: "Delete Form",
                                    para: `Are you sure you want to delete "${data?.title || "this form"}"? This action cannot be undone.`,
                                  });
                                }}
                              >
                                <HiOutlineTrash
                                  size={23}
                                  style={{
                                    backgroundColor: "red",
                                    padding: "5px",
                                    color: "white",
                                    borderRadius: "50%",
                                    pointerEvents: "none",
                                  }}
                                />
                              </IconButton>
                            </Tooltip>
                          )}
                        </>
                      ) : (
                        "-"
                      )}
                    </TableCell>

                    <TableCell style={{ textAlign: "left" }}>
                      <Switch
                        size="small"
                        onClick={(e) => {
                          e.stopPropagation();

                          if (editPermissions) {
                            setIsModalOpen({
                              id: data?._id || data?.id,
                              open: true,
                              currentComponent: "status",
                              type: "status",
                              head: "Change Status",
                              para: "Are you sure you want to Change the Status?",
                            });
                          } else {
                            dispatch(
                              notificationSuccess({
                                show: true,
                                type: "error",
                                message:
                                  "You don't have permission to change status",
                              })
                            );
                          }
                        }}
                        checked={data.status == 1 ? true : false}
                        disabled={data.status == 2 ? true : false}
                      />
                    </TableCell>
                    <TableCell style={{ textAlign: "left" }}>
                      <Switch
                        size="small"
                        onClick={(e) => {
                          e.stopPropagation();

                          if (editPermissions) {
                            setIsModalOpen({
                              id: data?._id || data?.id,
                              open: true,
                              currentComponent: "status",
                              type: "preview",
                              head: "Change Status",
                              para: "Are you sure you want to Change the Preview Status?",
                            });
                          } else {
                            dispatch(
                              notificationSuccess({
                                show: true,
                                type: "error",
                                message:
                                  "You don't have permission to change status",
                              })
                            );
                          }
                        }}
                        checked={data.isPreview == 1 ? true : false}
                        disabled={data.isPreview == 2 ? true : false}
                      />
                    </TableCell>
                    <TableCell>
                      <DropdownMenu.Root>
                        <DropdownMenu.Trigger className="chatDropDown">
                          <Button
                            buttonName={data.submissionCount}
                            color="white"
                            style={{ width: "100%" }}
                          />
                        </DropdownMenu.Trigger>
                      </DropdownMenu.Root>
                    </TableCell>
                  </TableRow>
                ))}
              {formData == null ? (
                <TableRow>
                  <TableCell
                    sx={{
                      color: "silver",
                      textAlign: "center",
                      paddingTop: "90px",
                      borderBottom: "none",
                      fontSize: "30px",
                    }}
                    colSpan="6"
                  >
                    No records to display
                  </TableCell>
                </TableRow>
              ) : formData && formData.length == 0 ? (
                <TableRowsLoader colNumber={9} rowsNum={10} />
              ) : (
                ""
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <div style={{ display: "flex", justifyContent: "flex-end" }}>
          <Pagination
            count={10}
            shape="rounded"
            totalData={totalData}
            page={page}
            setPage={setPage}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
          />
        </div>
      </Stack>
      <Modal
        modalOpen={isModalOpen}
        formik={formik}
        handleClose={() => {
          setIsModalOpen({ open: false, currentComponent: "", id: "" });
          formik.resetForm();
        }}
        data={groupData}
        handelClick={changeStatus}
      />
      <ExportModal
        open={exportModal.open}
        onClose={() => setExportModal({ open: false, formId: "", formTitle: "", submissionCount: 0 })}
        formId={exportModal.formId}
        formTitle={exportModal.formTitle}
        submissionCount={exportModal.submissionCount}
      />
    </>
  );
};

export default FormManagement;
